module.exports = __webpack_public_path__ + "img/check-gray.2bbfca60.svg";